// components/LoginForm.tsx
import { useForm } from 'react-hook-form'
import { useModal } from '@/hooks/useModal'
import { zodResolver } from '@hookform/resolvers/zod'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faGooglePlusG } from '@fortawesome/free-brands-svg-icons'
import { AuthFormType, ModalType } from '@/constants/common.contant'
import { LoginRequest, loginSchema } from '@/utils/schemas'
import { useAuth } from '@/hooks/useAuth'
import { SubmitButton } from '../Buttons'
import { Input } from '../Input'

interface Props {
  onFormSwitch: (formType: AuthFormType) => void
}

const LoginForm = ({ onFormSwitch }: Props) => {
  const { closeModal } = useModal(ModalType.Auth)
  const { signin, isLoggingIn } = useAuth()
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginRequest>({
    resolver: zodResolver(loginSchema),
    defaultValues: {
      email: '',
      password: '',
    },
  })

  const onSubmit = async (data: LoginRequest) => {
    try {
      await signin(data)
      closeModal()
    } catch (error) {
      throw Error('' + error)
    }
  }

  return (
    <form noValidate onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <h2 className="text-2xl font-bold text-center text-primary uppercase mb-4">ĐĂNG NHẬP</h2>
      <Input
        label="Email đã đăng ký"
        name="email"
        type="email"
        register={register}
        error={errors.email}
        placeholder="Nhập email của bạn"
      />
      <Input
        label="Mật khẩu"
        name="password"
        type="password"
        register={register}
        error={errors.password}
        placeholder="Nhập mật khẩu của bạn"
      />
      <p className="">
        Bạn quên mật khẩu?
        <button
          type="button"
          className="text-blue-500 underline ml-2"
          aria-label="forgot button"
          onClick={() => onFormSwitch(AuthFormType.ForgotPassword)}
        >
          Lấy lại mật khẩu
        </button>
      </p>
      <p>
        Chưa có tài khoản
        <button
          type="button"
          className="text-blue-500 underline ml-2"
          aria-label="register button"
          onClick={() => onFormSwitch(AuthFormType.Register)}
        >
          Đăng ký ngay
        </button>
      </p>
      {/* Đăng nhập với Facebook và Google */}
      <div className="flex items-center text-gray-500 gap-6">
        <hr className="flex-1" />
        <h3 className="px-2 m-0 text-gray-500">Đăng nhập với</h3>
        <hr className="flex-1" />
      </div>
      <div className="mt-4 flex items-center justify-around gap-6">
        <button
          type="button"
          className="flex items-center justify-center w-full bg-[#3b5998] text-white py-2 rounded-lg"
          aria-label="fb button"
        >
          <FontAwesomeIcon icon={faFacebook} className="mr-2" />
          Facebook
        </button>
        <button
          type="button"
          aria-label="gg button"
          className="flex items-center justify-center w-full bg-[#cc4034] text-white py-2 rounded-lg"
        >
          <FontAwesomeIcon icon={faGooglePlusG} className="mr-2" />
          Google
        </button>
      </div>
      <div className="flex items-center justify-around gap-6 border-t pt-6 mt-4">
        <button
          onClick={closeModal}
          type="button"
          aria-label="close M button"
          className="w-[80%] bg-white text-black border uppercase py-2 rounded"
        >
          đóng
        </button>
        <SubmitButton isLoading={isLoggingIn}>đăng nhập</SubmitButton>
      </div>
    </form>
  )
}

export default LoginForm
